// src/services/uploadService.js (or append to audioService.js)
import { supabase } from "../supabaseClient";
import { MY_BACKEND_URL } from "../supabaseClient";

/**
 * 1. Get Signed URL from Backend
 * @param {string} questionId - The UUID of the question (used as filename)
 * @param {string} mimeType - e.g., 'audio/webm'
 * @returns {Promise<{uploadUrl: string, gcsUri: string}>}
 * 
 */
export const getSignedUrl = async (questionId, mimeType) => {

    const { data: { session } } = await supabase.auth.getSession();

    if (!session || !session.user) {
        throw new Error("You must be logged in to join a meet");
    }

    // 2. Get the Access Token (this replaces getIdToken())
    const accessToken = session.access_token;
    // Replace with your actual backend URL
    const response = await fetch(`${MY_BACKEND_URL}/api/get-upload-url`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}` 
        },
        body: JSON.stringify({
            filename_uuid: questionId,
            contentType: mimeType
        })
    });

    if (!response.ok) {
        throw new Error('Failed to get upload slot from server');
    }

    return await response.json();
};

/**
 * 2. Upload to Google Cloud Storage
 * @param {string} signedUrl - The URL received from step 1
 * @param {Blob} fileBlob - The audio blob from your recorder
 * @param {string} mimeType - Must match what you sent in step 1
 */

export const uploadFileToGCS = async (signedUrl, fileBlob, mimeType) => {
  const res = await fetch(signedUrl, {
    method: "PUT",
    body: fileBlob,
    headers: {
      "Content-Type": mimeType,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`GCS upload failed (${res.status}): ${text}`);
  }

  // Signed URL uploads usually return 200/201 and empty body
  return true;
};
